import dadataService from './dadataService';

export default dadataService;



// WEBPACK FOOTER //
// ./src/services/dadata/index.ts